export enum InvoiceNameStatus {
    DRAFT = 'DRAFT',
    DUE = 'DUE',
    PAID = 'PAID',
    PAYMENT_FAILED = 'PAYMENT_FAILED',
    UNCOLLECTIBLE = 'UNCOLLECTIBLE',
}
